import { GetChapters, GetStuUp, GetClassAPI, GetBanjiAPI, GetSubjectAPI, GetTeaRoleAPI, GetBookVerAPI } from '@/api/eum'

export default {
  namespaced: true,
  state: {
    nianji: [], // 年级数据
    banji: [], // 班级数据
    subject: [], // 学科数据
    tearole: [], // 教师角色
    bookver: []// 教材版本设置
  },
  mutations: {
    setnianji(state, item) {
      state.nianji = item
    },
    setbanji(state, item) {
      state.banji = item
    },
    setsubject(state, item) {
      state.subject = item
    },
    settearole(state, item) {
      state.tearole = item
    },
    setbookver(state, item) {
      state.bookver = item
    }
  },
  actions: {
    // 获取年级的数据
    async  getclass({ commit }) {
      const res = await GetClassAPI()
      commit('setnianji', res)
      return res
    },
    // 获取班级的数据
    async getbanji({ commit }, item) {
      const res = await GetBanjiAPI(item)
      commit('setbanji', res)
      return res
    },
    // 获取学科数据
    async getsubject({ commit }) {
      const res = await GetSubjectAPI()
      commit('setsubject', res)
      return res
    },
    // 获取教师角色
    async gettearole({ commit }) {
      const res = await GetTeaRoleAPI()
      commit('settearole', res)
      return res
    },
    // 获取教材版本设置
    async getbookver({ commit }) {
      const res = await GetBookVerAPI()
      commit('setbookver', res.version)
      return res.version
    },
    // 学生年级升级
    async getstuup({ commit }) {
      await GetStuUp()
    },
    // 获取章节单元
    async getchap({ commit }, item) {
      const res = await GetChapters(item)
      return res
    }
  }
}
